import { Box, Typography } from '@mui/material'
import { color } from 'config/color'
import type React from 'react'

export const LoginBanner: React.FC = () => {
  return (
    <Box
      bgcolor={color.error[700]}
      py={3}
      color={color.white}
      borderRadius={0}
      textAlign='center'
      fontSize={20}
      fontWeight='900'
    >
      <Typography margin='auto' width='75%'>
        <b>
          We have upgraded our user portal on 02/02 with new features! Existing
          users MUST register with their new account number to login. <br />
        </b>
      </Typography>
    </Box>
  )
}
